import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import ErrorMessage from './ErrorMessage'
import { useFormContext } from '@context/FormContext'

const Select = ({ name, label, options, autocomplete = 'off', ...props }) => {
  const { values, errors, submitCount, setFieldValue, setFieldError } = useFormContext()
  
  const fieldValue = get(values, name) || ''
  const fieldError = get(errors, name)
  // Only show errors after user tries to submit (submitCount > 0)
  const fieldTouched = submitCount > 0

  const handleChange = (e) => {
    const newValue = e.target.value
    setFieldValue(name, newValue)
    // Clear error when user selects a value (if error exists)
    if (fieldError) {
      setFieldError(name, undefined)
    }
    props.onChange && props.onChange(e)
  }

  return (
    <div
      className={classNames(
        'mb-4',
        { 'opacity-60': props.disabled }
      )}
    >
      {label && (
        <label className="form-label" htmlFor={name}>
          {label}
        </label>
      )}

      <select
        {...props}
        id={name}
        name={name}
        className={classNames(
          'form-select',
          props.className
        )}
        onChange={handleChange}
        value={fieldValue}
      >
        <option value="">{props.placeholder || 'Select an option'}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <ErrorMessage render={!!(fieldError && fieldTouched)} message={fieldError} />
    </div>
  )
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  autocomplete: PropTypes.string,
  autofocus: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
  })).isRequired,
  className: PropTypes.string,
}

export default Select
